import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Lorem", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, " → ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Amet", -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "page-title" }, "Lorem ipsum dolor sit amet consectetur", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "downloads-list" }, [
          _createElementVNode("div", { class: "download-item" }, [
            _createElementVNode("div", { class: "download-info" }, [
              _createElementVNode("h3", null, "Lorem ipsum dolor"),
              _createElementVNode("p", null, "Lorem ipsum dolor sit amet")
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "btn-download"
            }, "Lorem")
          ]),
          _createElementVNode("div", { class: "download-item" }, [
            _createElementVNode("div", { class: "download-info" }, [
              _createElementVNode("h3", null, "Lorem ipsum dolor sit amet"),
              _createElementVNode("p", null, "Lorem ipsum dolor")
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "btn-download"
            }, "Lorem")
          ]),
          _createElementVNode("div", { class: "download-item" }, [
            _createElementVNode("div", { class: "download-info" }, [
              _createElementVNode("h3", null, "Lorem ipsum dolor r. r."),
              _createElementVNode("p", null, "Lorem ipsum dolor sit")
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "btn-download"
            }, "Lorem")
          ]),
          _createElementVNode("div", { class: "download-item" }, [
            _createElementVNode("div", { class: "download-info" }, [
              _createElementVNode("h3", null, "Lorem ipsum 7S"),
              _createElementVNode("p", null, "Lorem ipsum dolor sit amet")
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "btn-download"
            }, "Lorem")
          ]),
          _createElementVNode("div", { class: "download-item" }, [
            _createElementVNode("div", { class: "download-info" }, [
              _createElementVNode("h3", null, "Lorem PC-12"),
              _createElementVNode("p", null, "Lorem ipsum dolor")
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "btn-download"
            }, "Lorem")
          ]),
          _createElementVNode("div", { class: "download-item" }, [
            _createElementVNode("div", { class: "download-info" }, [
              _createElementVNode("h3", null, "Lorem ipsum dolor"),
              _createElementVNode("p", null, "Lorem ipsum dolor")
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "btn-download"
            }, "Lorem")
          ])
        ], -1))
      ])
    ]),
    _: 1
  }))
}